import styled from 'styled-components'

export const StyledImage = styled.img`
  width: 40px;
  margin-left: 10px;
  margin-right: 20px;
`
